import { Paper, TextBase, TooltipBubble } from '@carboncopyco/ui';
import { AspectRatio } from '@radix-ui/react-aspect-ratio';
import { useBoolean } from 'ahooks';
import type React from 'react';
import { Screenshot } from '../Screenshot';

type ScreenshotTileProps = {
  title: string;
  image?: string;
  overlay?: React.ReactElement;
  dropdown?: React.ReactElement;
  dropdownOpen?: boolean;
  icon?: React.ReactNode;
};

export const ScreenshotTile = ({
  title,
  image,
  overlay,
  dropdown,
  dropdownOpen,
  icon,
}: ScreenshotTileProps) => {
  const [isHover, setHover] = useBoolean(false);
  const active = isHover || dropdownOpen;

  return (
    <Paper radius>
      <div
        className="w-full relative"
        onMouseEnter={setHover.setTrue}
        onMouseLeave={setHover.setFalse}
      >
        <AspectRatio ratio={16 / 10}>
          {active && <div className="absolute inset-0 z-50">{overlay}</div>}
          <Screenshot
            image={image}
            alt="screenshot"
          />
        </AspectRatio>
        <div className="w-full flex items-center mt-1 mb-1 h-6">
          <div className="shrink overflow-x-hidden pr-2">
            <TooltipBubble
              placement="top-start"
              title={title}
            >
              <div className="text-ds-natural-400 truncate">
                <TextBase
                  ellipsis
                  label={title}
                  color="text-ds-natural-400"
                />
              </div>
            </TooltipBubble>
          </div>
          {active
            ? dropdown && <div className="w-9 ml-auto">{dropdown}</div>
            : icon && <div className="w-6">{icon}</div>}
        </div>
      </div>
    </Paper>
  );
};
